const MediaType = {
    VOD: 'VOD',
    LIVE: 'LIVE',
    LINEAR: 'LINEAR',
    UNSET: '',
};

export default MediaType;
